import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const RESOURCES = Resources.Campaigns.Campaign.DonationForm;

// currencySymbol comes from the campaign (the receiver's market currency) — an empty
// symbol (admin preview of a draft without a receiver) renders the message without one.
export const getDonationValidationSchema = (
  t: TFunction,
  currencySymbol: string,
  minAmount = 1,
) =>
  z.object({
    amount: z
      .number()
      .min(
        minAmount,
        t(RESOURCES.AmountMin, { minAmount, currencySymbol }).trim(),
      ),
  });

export type DonationFormData = z.infer<
  ReturnType<typeof getDonationValidationSchema>
>;
